// TODO: Add translations
export default {
  manageTeam: {
    active: 'Not Implemented.',
    add: 'Not Implemented.',
    addFailure: 'Not Implemented.',
    addingTeamMember: 'Not Implemented.',
    addSuccess: 'Not Implemented.',
    addTeamMember: 'Not Implemented.',
    canAccessSettings: 'Not Implemented.',
    cancel: 'Not Implemented.',
    delete: 'Not Implemented.',
    deleteFailure: 'Not Implemented.',
    teamMemberFailureNoConnection: 'Not Implemented.',
    deletePhoto: 'Not Implemented.',
    deleteSuccess: 'Not Implemented.',
    deleteTeamMember: 'Not Implemented.',
    deleteTeamMemberCheck: 'Not Implemented.',
    deletingTeamMember: 'Not Implemented.',
    displayName: 'Not Implemented.',
    displayNameMustBeUnique: 'Not Implemented.',
    editTeamMember: 'Not Implemented.',
    fullName: 'Not Implemented.',
    fullNameMustBeUnique: 'Not Implemented.',
    inactive: 'Not Implemented.',
    justNow: 'Not Implemented.',
    loadingTeamData: 'Not Implemented.',
    manageTeam: 'Not Implemented.',
    mustBeANumericValue: 'Not Implemented.',
    noRegisteredMembers: 'TNot Implemented.',
    noRegisteredMembersInSearch: 'Not Implemented.',
    permission: 'Not Implemented.',
    photoRequired: 'Not Implemented.',
    pin: 'Not Implemented.',
    pinMustBeAtLeastNCharactersLong: 'Not Implemented.',
    pinMustBeUnique: 'Not Implemented.',
    pinMustNotBeMoreThanNCharactersLong: 'Not Implemented.',
    save: 'Not Implemented.',
    searchForTeamMember: 'Not Implemented.',
    selectATeam: 'Not Implemented.',
    status: 'Not Implemented.',
    takePhoto: 'Not Implemented.',
    teamCategory: 'Not Implemented.',
    updateFailure: 'Not Implemented.',
    updateSuccess: 'Not Implemented.',
    updatingTeamMemberDetails: 'Not Implemented.',
    uploadImage: 'Not Implemented.',
    uploadPhoto: 'Not Implemented.',
    warning: 'Not Implemented.',
    weight: 'Not Implemented.',
    weightMustBeGreaterThanOrEqualToN: 'Not Implemented.',
    weightMustBeLessThanOrEqualToN: 'Not Implemented.'
  }
};